const WHATSAPP_DEFAULT_TEXT = "Hola, necesito soporte.";

/** wa.me link to the support chat: only the digits of `phone` count; without a phone, the bare wa.me. */
export const buildWhatsAppSupportUrl = (phone) => {
  const digits = String(phone || "").replace(/\D/g, "");
  return digits
    ? `https://wa.me/${digits}?text=${encodeURIComponent(WHATSAPP_DEFAULT_TEXT)}`
    : "https://wa.me/";
};
